import { notification } from 'antd';

// Profesyonel notification sistemi
export const showNotification = (
  type: 'success' | 'error' | 'info' | 'warning', 
  title: string, 
  description: string
) => {
  notification[type]({
    message: title,
    description,
    placement: 'topRight',
    duration: 4.5,
  });
};



// Veri temizleme fonksiyonu
export const cleanFormData = (values: any, type: 'company' | 'user') => {
  const baseClean = {
    ...values,
    email: values.email?.toLowerCase().trim(),
    phone: values.phone?.replace(/\s/g, ''),
  };

  if (type === 'company') {
    return {
      ...baseClean,
      name: values.name?.trim(),
      taxNumber: values.taxNumber?.replace(/\s/g, ''),
      taxOffice: values.taxOffice?.trim(),
      address: values.address?.trim(),
    };
  }

  return {
    ...baseClean,
    firstName: values.firstName?.trim(),
    lastName: values.lastName?.trim(),
  };
};